export function renderInline(text) {
  return text
    .split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g)
    .filter(Boolean)
    .map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**"))
        return <strong key={i} className="font-semibold text-foreground">{part.slice(2, -2)}</strong>;
      if (part.startsWith("*") && part.endsWith("*"))
        return <em key={i} className="font-display italic text-foreground">{part.slice(1, -1)}</em>;
      return <span key={i}>{part}</span>;
    });
}

export function RichBlocks({ text }) {
  const rawLines = (text || "").split("\n");
  const blocks = [];
  let para = [];
  let list = [];
  const flushPara = () => {
    if (!para.length) return;
    const lines = para;
    blocks.push(
      <p key={`p-${blocks.length}`} className="text-white/85 font-normal leading-[1.8]">
        {lines.map((l, i) => (
          <span key={i}>
            {i > 0 && <br />}
            {renderInline(l.trim())}
          </span>
        ))}
      </p>
    );
    para = [];
  };
  const flushList = () => {
    if (!list.length) return;
    const items = list;
    blocks.push(
      <ul key={`ul-${blocks.length}`} className="space-y-3">
        {items.map((item, i) => (
          <li key={i} className="flex gap-3 text-white/85 font-normal leading-[1.8]">
            <span className="mt-[0.65em] inline-block w-2 h-2 bg-accent shrink-0" />
            <span>{renderInline(item)}</span>
          </li>
        ))}
      </ul>
    );
    list = [];
  };
  rawLines.forEach((line) => {
    const t = line.trim();
    if (!t) {
      flushPara();
      flushList();
      return;
    }
    if (t.startsWith("- ")) {
      flushPara();
      list.push(t.slice(2));
      return;
    }
    flushList();
    para.push(t);
  });
  flushPara();
  flushList();
  return <div className="space-y-5" data-testid="casting-description">{blocks}</div>;
}

export const stripMarks = (text = "") => text.replace(/\*\*?([^*]+)\*\*?/g, "$1");
